title: Agenda
labels:
  allUsers: Alle medewerkers
  userCount: "{count} medewerker|{count} medewerkers"
  users: Medewerkers
  appointmentDetails: Afspraakdetails
  treatmentName: Behandeling
  date: Datum
  duration: Duur
  time: Tijd
  comment: Opmerkingen
  today: Vandaag
  absence: Afwezig
  fullDay: Hele dag
  user: Medewerker
  startDate: Van
  endDate: Tot
  absenceDetails: Afwezigheidsdetails
  startTime: Starttijd
  endTime: Eindtijd
  noShow: No-show
  capacity: Capaciteit
  capacityOverview: "{count} van de {max} plekken is bezet"
  participants: Deelnemers
actions:
  noShow: No-show
  removeNoShow: Verwijder no-show
  duplicateAppointment: Behandeling herhalen
fields:
  date: Datum
  time: Tijd
  comment: Opmerkingen
  isFullDay: Hele dag
  startDate: Van datum
  endDate: Tot datum
  startTime: Starttijd
  endTime: Eindtijd
messages:
  absenceDetails: Details van de geselecteerde afwezigheid.
  searchInCalendar: Zoek afspraken, klanten of behandelingen...
  noAppointmentsFound: Geen afspraken gevonden voor "{text}"
  whatWouldYouLikeToAdd: Wat wil je toevoegen?
  chooseOptionToProceed: Kies een optie om door te gaan.
  noCalendarItems: Geen afspraken op deze dag
  appointmentDetails: Details van de geselecteerde afspraak.
  removeCalendarItem: Afwezigheid verwijderen
  removeCalendarItemInfo: Weet je zeker dat je deze afwezigheid wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.
  removeAppointment: Afspraak verwijderen
  removeAppointmentInfo: Weet je zeker dat je deze afspraak wilt verwijderen? De klant krijgt hier ook een bevestiging van via de mail.
  appointment:
    title: Nieuwe afspraak maken
    description: Plan een nieuwe afspraak in voor een klant
    subtitle: Maak een nieuwe afspraak aan door de booking flow te doorlopen.
  absence:
    title: Afwezigheid inplannen
    description: Blokkeer tijd voor vakantie, ziekte of andere afwezigheid
    subtitle: Plan afwezigheid in voor één of meerdere medewerkers.
enums:
  display:
    day: Dag
    week: Week
    month: Maand
  appointmentChanged:
    individualMoved:
      title: Afspraak verplaatsen
      body: Weet je zeker dat je deze afspraak wilt verplaatsen naar {updatedDate} {updatedTime}? De klant zal hier ook een bevestigingsmail van ontvangen.
    groupMoved:
      title: Afspraak verplaatsen
      body: Weet je zeker dat je deze groepsafspraak wilt verplaatsen naar {updatedDate} {updatedTime}? Alle deelnemers ontvangen hiervan een bevestigingsmail.
    individualExtendTime:
      title: Afspraak verlengen
      body: Weet je zeker dat je deze afspraak wilt verlengen naar {updatedTime} (was {originalTime}) op {updatedDate}? De klant ontvangt hiervan ook een bevestigingsmail.
    individualShortenTime:
      title: Afspraak inkorten
      body: Weet je zeker dat je deze afspraak wilt inkorten naar {updatedTime} (was {originalTime}) op {updatedDate}? De klant ontvangt hiervan ook een bevestigingsmail.
    groupExtendTime:
      title: Afspraak verlengen
      body: Weet je zeker dat je deze groepsafspraak wilt verlengen naar {updatedTime} (was {originalTime}) op {updatedDate}? Alle deelnemers ontvangen hiervan een bevestigingsmail.
    groupShortenTime:
      title: Afspraak inkorten
      body: Weet je zeker dat je deze groepsafspraak wilt inkorten naar {updatedTime} (was {originalTime}) op {updatedDate}? Alle deelnemers ontvangen hiervan een bevestigingsmail.
